import { render } from "./OCRLines.vue?vue&type=template&id=13479b33&scoped=true&ts=true"
import script from "./OCRLines.vue?vue&type=script&lang=ts"
export * from "./OCRLines.vue?vue&type=script&lang=ts"

import "./OCRLines.vue?vue&type=style&index=0&id=13479b33&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13479b33"]])

export default __exports__